import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterTypeEntretienByNamePipe } from 'src/app/shared/pipes/filter-typeEntretien-by-name/filter-typeEntretien-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ListTypeEntretienComponent } from './list-typeEntretien/list-typeEntretien.component';
import { TypeEntretienModalAjoutComponent } from './modal/typeEntretien-modal-ajout/typeEntretien-modal-ajout.component';
import { TypeEntretienModalDetailComponent } from './modal/typeEntretien-modal-detail/typeEntretien-modal-detail.component';

@NgModule({
	declarations: [
		ListTypeEntretienComponent,
		TypeEntretienModalDetailComponent,
		TypeEntretienModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterTypeEntretienByNamePipe]
})

export class TypeEntretienModule {}
